import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";
const Balance = () => {
  const { incomeTransactions, expenseTransactions } = useContext(GlobalContext);

  const incomeAmounts = incomeTransactions.map(
    (incomeTransaction) => incomeTransaction.incomeAmount
  );

  const expenseAmounts = expenseTransactions.map(
    (expenseTransaction) => expenseTransaction.expenseAmount
  );

  const totalIncome = incomeAmounts
    .reduce((acc, currItem) => acc + currItem, 0)
    .toFixed(2);

  const totalExpense = expenseAmounts
    .reduce((acc, currItem) => acc + currItem, 0)
    .toFixed(2);

  return (
    <div className="balance">
      <h1>Your Balance</h1>
      <h3>${(totalIncome - totalExpense).toFixed(2)}</h3>

      <div className="income-expense">
        <div className="plus">
          <h3>Income</h3>
          <p>+${totalIncome}</p>
        </div>

        <div className="minue">
          <h3>Expense</h3>
          <p>-${totalExpense}</p>
        </div>
      </div>
    </div>
  );
};
export default Balance;
